const initState = {
    /// README: COMPANY API CALL
    hepiMessage: "",
    showHepiLoaprojecer: false,
    hepiid: -1,
}

const customerServiceReducer = (state = initState, action) => {
    if (action.type === "HEPI_CALL_INIT" || action.type === "HEPI_CALL_COMPLETED" || action.type === "HEPI_CALL_ERROR") {
        return {
            ...state,
            hepiMessage: action.hepiMessage,
            showHepiLoader: action.showHepiLoader,
            hepiid: action.hepiid,
        }
    }

    return state;
}

export default customerServiceReducer;